import { DEVICE_BASE_COLUMNS, DeviceBase } from "./devices";
import { ColumnsOf } from "../data";
import { Maybe } from "../utility";

export const assetType = {
  Mobile: "asset.mobile",
  Physical: "asset.physical",
  Mock: "asset.mock"
} as const;

export const allAssetTypes = Object.values(assetType);

export type AssetType = (typeof assetType)[keyof typeof assetType];

export interface Asset extends DeviceBase<AssetType> {
  missing_at: Maybe<string>;
}

export type AssetInsert = Pick<Asset, "name" | "tid" | "space_id" | "tags" | "type" | "person">;

export type AssetUpdate = Partial<Pick<Asset, "name" | "tid" | "space_id" | "tags" | "person">>;

export const ASSET_COLUMNS: ColumnsOf<Asset> = [...DEVICE_BASE_COLUMNS] as const;
